import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import KwPanel from '../../common/KwPanel';
import FormInput from '../../common/FormInput';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../../../hooks';
import { saveGameFranchise } from '../../../reducers/gameReducer';
import { GameFranchiseModel } from '../../../types/swagger-dtos/GamesDtos';
interface GameFranchiseProps {
    gameFranchise?: GameFranchiseModel | null;
    cancel: () => void;
    done: (savedGameFranchise: any) => void;
    handleDelete?: () => void;
}
function GameFranchise({ gameFranchise, cancel, done, handleDelete = () => {} }: GameFranchiseProps) {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const {
        register,
        formState: { errors },
        handleSubmit,
    } = useForm();
    const onSubmit = (data: any) => {
        dispatch(saveGameFranchise({ id: gameFranchise?.id, ...data }))
            .unwrap()
            .then((savedGameFranchise) => {
                toast.success(t('Game franchise saved'));
                done(savedGameFranchise);
            })
            .catch((e) => {
                toast.error(e.message ?? t('Failed to save game franchise'));
            });
    };
    return (
        <SlideoutLayout
            title={`${gameFranchise ? t('Edit game franchise') : t('Add game franchise')}`}
            cancel={cancel}
            bar={
                <>
                    {gameFranchise && (
                        <Button
                            className="btn btn-danger ms-2 d-none d-md-inline-flex"
                            onClick={handleDelete}
                            text={t('Delete')}
                        />
                    )}
                    <Button
                        type="submit"
                        text={t('Save')}
                        onClick={handleSubmit(onSubmit)}
                        className="btn btn-primary ms-2"
                        testId="save-game-franchise-button"
                    />
                </>
            }
        >
            <KwPanel className="mb-4 pb-3 pt-1">
                <FormInput
                    register={register}
                    required={true}
                    error={errors.name}
                    errorMessage={t('Name is required')}
                    name="name"
                    label={t('Name')}
                    placeholder={t('Name of the game franchise')}
                    defaultValue={gameFranchise?.name || ''}
                    autoFocus={true}
                    testId="game-franchise-name" />
            </KwPanel>
        </SlideoutLayout>
    );
}
export default GameFranchise;